/**
 * Document Records API (Visa/Permit/Passport tracking) — list, get, create, update, delete, bulkImport, sign.
 */

import { apiFetch } from './core'

export const docRecords = {
    list: (params = {}) => {
        const qs = new URLSearchParams(params).toString()
        return apiFetch(`/doc-records${qs ? `?${qs}` : ''}`)
    },
    get: (id) => apiFetch(`/doc-records/${id}`),
    create: (data) => apiFetch('/doc-records', {
        method: 'POST',
        body: JSON.stringify(data),
    }),
    update: (id, data) => apiFetch(`/doc-records/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(data),
    }),
    delete: (id) => apiFetch(`/doc-records/${id}`, { method: 'DELETE' }),
    bulkImport: (records) => apiFetch('/doc-records/bulk-import', {
        method: 'POST',
        body: JSON.stringify({ records }),
    }),
    sign: (id, agree_to_terms) => apiFetch(`/doc-records/${id}/sign`, {
        method: 'POST',
        body: JSON.stringify({ agree_to_terms }),
    }),
}
